<dropdown-select
	[options]="options"
	[queryParam]="queryParam"
	multiple="true"
></dropdown-select>
